import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';

@Injectable({
    providedIn: 'root'
})
export class TimelineWebSocketService {
    private socket!: Socket;
    private readonly WS_ENDPOINT = 'ws://localhost:3004/api/notification';
    constructor() {
    }

    public connect() {
        this.socket = io(this.WS_ENDPOINT)

        this.socket.on('connect', () => {
            console.log('websocket connected')
        })

        // this.socket.on('timelineUpdate', (data: any) => {
        //     console.log('Received timelineUpdate:', data);
        // });
        this.socket.on('error', (error) => {
            console.log('websocket error', error)
        })
        this.socket.on('disconnect', () => {
            console.log('websocket closed')
        })
    }

    public disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            console.log('websocket disconnected')
        }
    }

    sendMessage(message: any) {
        if (this.socket && this.socket.connected) {
            console.log('coming inside')
            this.socket.emit('joinRoom', message);
            this.socket.on('timelineUpdate', (data: any) => {
                console.log('listen value', data)
            })
        } else {
            console.error('WebSocket is closed. Reconnecting...');
            this.connect();
            setTimeout(() => {
                this.socket.emit('joinRoom', message);
                this.socket.on('timelineUpdate', (data: any) => {
                    console.log(data);

                    alert(JSON.stringify(data, null, 2));
                })
            }, 1000);
        }
    }

    createTimelineEntry(commentData: any) {
        if (this.socket && this.socket.connected) {
            this.socket.emit('createTimelineEntry', commentData.newEntry, (response: any) => {
                console.log('Server response:', response);
                if (response.status === 'success') {
                    console.log('Timeline entry saved:', response.data);
                } else {
                    console.error('Error:', response.message);
                }
            });
        }
    }

    // listenForEvent(event: string): Observable<any> {
    //     console.log('listenForEvent', event)
    //     return new Observable(observer => {
    //         const subscription = this.socket.on(event, (message: any) => {
    //             console.log('message', message)
    //             if (message.event === event) {
    //                 observer.next(message.data);
    //             }
    //         });
    //         return () => subscription.off(event);
    //     });
    // }

    closeConnection() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }
}
